import { Fieldset } from "@mantine/core";
import { FormFieldController } from "../../../../BuildingBlocks/Forms/Controllers/FormFieldController";
import { GENERATOR_FORM_DATA } from "../../GeneratorModal.constants";
import type { GeneratorFormSectionProps } from "../../GeneratorModal.types";

function SolarPremiumSection({ generatorForm }: GeneratorFormSectionProps) {
  const {
    control,
    formState: { errors }
  } = generatorForm;
  return (
    <Fieldset legend="Details zum Projektierer">
      <FormFieldController
        control={control}
        data={GENERATOR_FORM_DATA["pv_projector"]}
        error={errors.pv_projector}
      />
      <FormFieldController
        control={control}
        data={GENERATOR_FORM_DATA["pv_projector_contact"]}
        error={errors.pv_projector_contact}
      />
      <FormFieldController
        control={control}
        data={GENERATOR_FORM_DATA["pv_projector_contact_mail"]}
        error={errors.pv_projector_contact_mail}
      />
      <FormFieldController
        control={control}
        data={GENERATOR_FORM_DATA["pv_projector_contact_phone"]}
        error={errors.pv_projector_contact_phone}
      />
    </Fieldset>
  );
}

export { SolarPremiumSection };
